import {encode as base64_encode} from 'base-64';
import {useEffect, useState} from 'react';
import {ButtonCopyToClipboard} from './ButtonCopyToClipboard';
import './Security.css';
export const Security = () => {
	const [basicAuthResult, setBasicAuthResult] = useState<string>('');
	const [basicAuthUser, setBasicAuthUser] = useState<string>('');
	const [basicAuthPassword, setBasicAuthPassword] = useState<string>('');
	useEffect(() => {
		updateResult();
	}, [basicAuthPassword, basicAuthUser]);
	const updateResult = () => {
		const fullString = base64_encode(`${basicAuthUser}:${basicAuthPassword}`);
		setBasicAuthResult('Authorization: Basic ' + fullString);
	};
	return (
		<div className='basicauth panel'>
			<h2>Basic Authentication Header Generator</h2>
			<div className='basicauth-user-password'>
				<div className='basicauth-item'>
					<input
						autoFocus
						type={'text'}
						maxLength={1000}
						value={basicAuthUser}
						onChange={(e) => {
							setBasicAuthUser(e.target.value);
						}}
						placeholder='Username'
					/>
				</div>
				<div>:</div>
				<div className='basicauth-item'>
					<input
						type='password'
						maxLength={100}
						value={basicAuthPassword}
						onChange={(e) => {
							setBasicAuthPassword(e.target.value);
						}}
						placeholder='Password'
					/>
				</div>
			</div>
			<div className='code basicauth-result'>
				<p>The Result:</p>
				<p className='code'>{basicAuthResult}</p>
				<div className='buttons'>
					<div>
						<ButtonCopyToClipboard text={basicAuthResult} />
					</div>
					<div>
						<button
							key='Clear all'
							onClick={() => {
								setBasicAuthPassword('');
								setBasicAuthUser('');
							}}
						>
							Clear all
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};
